// Option lists shared with the startup registration form, used by the investor search filters.
import { countryToCode } from './stringUtils';

export const STARTUP_VERTICALS = [
    "Adtech / Media tech",
    "Advanced manufacturing",
    "Agtech / Farmtech",
    "Artificial intelligence and machine learning (AI/ML)",
    "Audiotech",
    "Augmented reality (AR)",
    "Autonomous cars",
    "B2B payments",
    "Beauty",
    "Big Data",
    "Biotech",
    "Cannabis",
    "Carsharing",
    "Cleantech",
    "Climate tech",
    "Cloudtech and DevOps",
    "Construction technology",
    "Cryptocurrency and blockchain",
    "Cybersecurity",
    "Deeptech",
    "Digital health",
    "Ecommerce",
    "Edtech",
    "Ephemeral content",
    "eSports / Sport tech",
    "Fashiontech",
    "Femtech",
    "Fintech",
    "Foodtech",
    "Gaming",
    "Healthtech",
    "HRtech",
    "Impact investing",
    "Industrials",
    "Infrastructure",
    "Insurtech",
    "Internet of Things (IoT)",
    "Legal tech",
    "Life sciences",
    "Lifestyles of Health and Sustainability (LOHAS) and wellness",
    "Logitech / Logistics",
    "Manufacturing",
    "Marketing tech",
    "Micro-mobility",
    "Mobile",
    "Mobile commerce",
    "Mobility tech",
    "Mortgage tech",
    "Nanotechnology",
    "Oil and gas",
    "Oncology",
    "Pet tech",
    "Real estate tech / Proptech",
    "Restaurant tech",
    "Ridesharing",
    "Robotics and drones",
    "Software as a service (SaaS)",
    "Space tech",
    "Supply chain technology",
    "Sustainability",
    "Traveltech",
    "Technology, media and telecommunications (TMT)",
    "Virtual reality (VR)",
    "Wearables and quantified self",
    "3D printing"
];

export const STARTUP_STAGES = [
    "Pre-seed",
    "Seed",
    "Growth- series A",
    "Growth- series B",
    "Growth- series C and C+"
];

export const RAISE_RANGES = [
    "$250,000-$500,000 USD",
    "$500,000-$1,000,000 USD",
    "$1,000,000-$5,000,000 USD",
    "$5,000,000-$10,000,000 USD",
    "$10,000,000+ USD"
];

export const COUNTRIES = Object.keys(countryToCode).sort();
